import actions from '../actions';

const initState = {
  selected_category: null,
  categories: [],
  loading: false
};

export default function categoryReducer(state = initState, action) {
  switch (action.type) {
    case actions.category.INIT:
      return {};
    case actions.category.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
